// globalQueue.js
// https://chatgpt.com/c/69150e0b-e69c-832e-9d38-38986a12cc7c
// A simple FIFO queue for guaranteeing one-at-a-time initialization.
let queue = []
let active = false

export function enqueueInitialization(runInit) {
  queue.push(runInit)
  processQueue()
}

function processQueue() {
  if (active) return
  if (queue.length === 0) return

  active = true
  const next = queue.shift()

  // runInit must return a Promise
  next().finally(() => {
    active = false
    // process next item on next tick
    setTimeout(processQueue, 0)
  })
}
